import {
    Component,
    OnInit,
  } from '@angular/core';
  import * as _ from 'lodash';
  import { FlashService } from '../../components/flash/flash.service';
  import { ActivatedRoute, Router } from '@angular/router';
import { LocationCollection } from '../location-collections';
import { LocationCollectionsService } from '../location-collections.service';
  
  @Component({
    selector: 'app-new-location-collection',
    templateUrl: './new.component.html',
    styleUrls: ['./new.component.scss'],
    standalone: false
})
  export class NewLocationCollectionComponent implements OnInit {
    locationCollection: LocationCollection = new LocationCollection();
    constructor(
      protected locationCollectionService: LocationCollectionsService,
      private flashService: FlashService,
      private router: Router,
      private route: ActivatedRoute
    ) {
    }
  
    ngOnInit() {
    }

    showFlashMessage(type: string, message: string){
      this.flashService.add({
        type: type,
        message: message
      });
    }

    addLocationCollection() {  
      this.create();
    }
  
    private create() {
      this.locationCollectionService.create(this.locationCollection).subscribe(() => {
        this.router.navigate(['/locations'])
        this.showFlashMessage("success", `The location collection has been created.`);        
      });
    }
  }
  